module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "float-button-section",
    class: [_vm.visible ? 'fade-in' : 'fade-out']
  }, [_vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "float-button"
  }, [_c('span', [_c('i', {
    staticClass: "icon iconfont icon-pen"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-755f9026","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FloatButton.vue
// module id = 248
// module chunks = 1